import axios from "axios";
import StorageUtils from "../utils/StorageUtils";

const api = axios.create({
  // baseURL: "https://api-agriholmes-prov.azurewebsites.net/api/",
  // baseURL: "https://sistema.pontualsys.com.br/api-agriholmes/api/",
  baseURL: "https://painel-agriholmes-prd.net/api/",
});

api.interceptors.request.use(
  async (config: any) => {
    const accessToken = await StorageUtils.getToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`
    }

    return config
  },
  (err: any) => Promise.reject(err)
)

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: any) => {
    if (error?.response?.data) {
      return Promise.reject({ message: error.response.data });
    }

    return Promise.reject(error);
  }
)

export default api;